import { required, optional } from "AppReact/schema";

export const uploadingTracker = {
  id: required("string"),
  video_id: optional("string"),
  uploadedChunks: required("integer"),
  totalChunks: required("integer"),
  finalStatus: required("string"),
};

export const uploadingTrackerDefaultValue ={
  id: "",
  video_id: null,
  uploadedChunks: 0,
  totalChunks: 0,
  finalStatus: "",
}
